import { store } from '@redux/store';
import uiStateSlice from 'layout/redux/uiStateSlice';
import { fromEvent, filter, map } from "rxjs";
import handlerErrorImages from './handlerErrorImages';

const listingForYouContainer = document.querySelector('[data-listings-for-you-container]');

// fix images with error.
handlerErrorImages(listingForYouContainer);

const containerClick$ = fromEvent(listingForYouContainer, 'click');

const isStandardCard = (event) => !!event.target.closest('[data-standard-card]');
const isAnchorElement = (event) => event.target instanceof HTMLAnchorElement;
const isFavoriteIcon = (event) => !!event.target.closest('.icon__save');
const isLeadOpener = (event) => !!event.target.closest('[data-lead-generator-opener]');

const cardClick$ = containerClick$.pipe(
  filter(isStandardCard), 
  filter(event => !isFavoriteIcon(event)),
  filter(event => !isAnchorElement(event)),
  filter(event => !isLeadOpener(event)),
);

const leadOpenerClick$ = containerClick$.pipe(
  filter(event => isLeadOpener(event)),
  map((event) => event.target.closest('[data-card]'))
);

const openLeadModal = function(id, type){
  store.dispatch(uiStateSlice.actions.modalInformation({ id, type, name: 'leadModal' }));
}

const redirectToDetailPage = function(event){
  const standardCardElement = event.target.closest('[data-standard-card]');
  const url = event.target?.dataset?.url ?? standardCardElement?.querySelector('a')?.href;

  window.open(url, '_blank');
}

cardClick$.subscribe(redirectToDetailPage);
leadOpenerClick$.subscribe((leadOpener) => openLeadModal(leadOpener.dataset.id, leadOpener.dataset.type));